import { useCallback, useMemo, useState } from "react";

const useFilterCanalDireto = () => {
  const [client, setClient] = useState("");
  const [clerk, setClerk] = useState("");
  const [agencia, setAgencia] = useState("");
  const [estado, setEstado] = useState(0);
  const [executivo, setExecutivo] = useState("");
  const [midia, setMidia] = useState(0);
  const [observacoes, setObservacoes] = useState("");
  const [motivo, setMotivo] = useState(0);
  const [check_in, setCheckIn] = useState(null);
  const [check_out, setCheckOut] = useState(null);
  const [status, setStatus] = useState([]);

  const changeFilterCanalDireto = useCallback(async (name, value) => {
    switch (name) {
      case "client":
        return setClient(value);
      case "clerk":
        return setClerk(value);
      case "agencia":
        return setAgencia(value);
      case "estado":
        return setEstado(value);
      case "executivo":
        return setExecutivo(value);
      case "midia":
        return setMidia(value);
      case "observacoes":
        return setObservacoes(value);
      case "motivo":
        return setMotivo(value);
      case "check_in":
        return setCheckIn(value);
      case "check_out":
        return setCheckOut(value);
      case "status":
        return setStatus(value);
      default:
        return null;
    }
  }, []);

  return useMemo(
    () => ({
      filterCanalDireto: {
        client,
        clerk,
        agencia,
        estado,
        executivo,
        midia,
        observacoes,
        motivo,
        check_in,
        check_out,
        status,
      },
      changeFilterCanalDireto,
    }),
    [
      client,
      clerk,
      agencia,
      estado,
      executivo,
      midia,
      observacoes,
      motivo,
      check_in,
      check_out,
      status,
      changeFilterCanalDireto,
    ]
  );
};

export default useFilterCanalDireto;
